
import React, {FC} from 'react';
import classNames from 'classnames';
import {RenderProps} from 'components/Assistant/ChatArea/renderer';
import {Scroller} from 'components/Assistant/ChatResponse/Scroller';
import {ResponseANL} from 'components/Assistant/hooks/parser';
import {Assistant} from 'components/Assistant/hooks/types';
import Button from 'components/Button';
import {Markdown} from 'components/Markdown';
import {navigate} from 'gatsby';
import {shuffle} from 'lodash';
import {SLEvent, smartlook} from 'utils/window/smartlook';

import * as styles from './styles.module.scss';

type ANLProps = RenderProps & {
	className?: string
	parsed: ResponseANL
	scroller?: boolean
	send: Assistant['send']
}

export const ANL: FC<ANLProps> = ({message, parsed, ...props}) => {
	const showLinks = parsed.user_links.length > 0;
	const showAnswers = props.isLast && parsed.user_answers.length > 0;
	const showSeparator = showLinks && showAnswers;

	return (
		<>
			<div className={classNames(styles.response, props.className)}>
				<Markdown
					markdown={parsed.bot_message}
					track={props.track}
				/>
			</div>

			{/* Show possible links first, track if clicked */}
			{showLinks && parsed.user_links.map(({target, description}, i) => (
				<Button
					key={`${message.id}:link:${i}`}
					className={styles.button}
					variant='primary'
					onClick={() => {
						if (props.track) {
							smartlook.track(SLEvent.LinkClick, {
								source: props.track,
								target,
							});
						}
						navigate(target);
					}}
				>
					{description}
				</Button>
			))}

			{/* Show separator between links and answers */}
			{showSeparator && <div className={styles.separator} />}

			{/* Show potential answers at the end */}
			{showAnswers && shuffle(parsed.user_answers).map(({option}, i) => (
				<Button
					key={`${message.id}:user:${i}`}
					className={styles.button}
					variant='chat-blue'
					onClick={() => props.send(option)}
				>
					{option}
				</Button>
			))}

			{/* Scroll to the bottom (using size-0 div) */}
			{props.scroller && <Scroller />}
		</>
	);
};
